console.log('js/tp_proper_search.js -> v0.1.0');
// tp_autocomplete START
$(function() {
	var hook = function(e) {
		var code = e.keyCode || e.which;
		if(code == 13) {
			var url = $('#autocomplete_results li a').first().attr('href');
			if(url && url.length > 0){
				window.location.href = url;
			};
		} else {
			var val = $(this).val()
			var elem = $(this)

			$('.sf_filter_group').addClass('hidden');
			$('.ddc_wrapper').addClass('hidden');

			if(val.length > 0){
				$('.sf_dropdown_filtering__noresults').addClass('hidden')

				var xhr = new XMLHttpRequest();
				var prefix = selectedLanguage == 'en' ? '' : '/' + selectedLanguage;
				xhr.open('GET', prefix + '/test-dest-search?dest_id='+destinationID+'&query=' + encodeURI(val));
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.send(null);
				xhr.onreadystatechange = function () {
					// ignore keys while we were waiting for response
					if ($(elem).val() != val) {
						return;
					}
					if (xhr.readyState === 4) {
						$('#autocomplete_results').remove()
						var res = $("<div id=autocomplete_results></div>")
						$(elem).parent().append(res)

						if (xhr.status === 200) {
						   var data = JSON.parse(xhr.responseText);
						   var inner = "<ul style='margin-top: 10px; list-style: none;'>"
						   var seen = {}
						   var total = 0;
						   if (data.hits.hits.length > 0) {
							   for (var i = 0; i < data.hits.hits.length; i++) {
								   var hit = data.hits.hits[i]._source

								   if (seen[hit.destination_id]) continue;
								   seen[hit.destination_id] = true;

									var name = hit.name
									if (hit.country) {
										name += ', ' + hit.country
									}

									var n = hit["listings_" + siteid];
									if (n > 0)
										name += ' ('+n+')'

									var langToId = {
										"fr":{id: 48, lang: "fr"},
										"en":{id: 41, lang: "en"},
										"de":{id: 52, lang: "de"},
										"es":{id: 149, lang: "es"},
										"nl":{id: 39, lang: "nl"},
										"pl":{id: 127, lang: "pl"},
									}

									var lang = langToId[selectedLanguage] || langToId["en"]
									var path = hit.paths[lang.id]

									inner +=  "<li style='margin: 5px;'><a class='ddc_2' href='/"+lang.lang+"/all/d/"+path+"'>"+name+"</a></li>"
									if (total++ >= 4) break;
							   }
							   inner += "</ul>"
							   res.html(inner)
							} else {
								$('.sf_dropdown_filtering__noresults').removeClass('hidden')
							}
					   } else {
						   $('#autocomplete_results').remove();
						   $('.sf_dropdown_filtering__noresults').removeClass('hidden')
					   }
				   }
			   }
			} else {
				$('#autocomplete_results').remove();
				$('.sf_filter_group').removeClass('hidden');
				$('.ddc_wrapper').removeClass('hidden');

			};
		}
	}
	if ($('.js_sf_dropdown_filtering').attr('autocomplete_enabled')) {
		$('.js_sf_dropdown_filtering').keyup(hook)
	}
})
// tp_autocomplete END
